var isFunction = require('./function')

/**
 * @func isMatcher
 * @memberOf is
 * @since 3.0.0
 *
 * @param  {*} x value to check
 * @return {boolean} isFunction || isRegExp
 *
 * @example
 *
 *    isMatcher(/(.*)/)
 *    //=> true
 *
 *    isMatcher(x => true)
 *    //=> true
 *
 *    isMatcher(1)
 *    //=> false
 *    isMatcher('.*')
 *    //=> false
 *
 */
module.exports = function (x) { return isFunction(x) || x instanceof RegExp; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWF0Y2hlci5qcyIsInNvdXJjZXMiOlsibWF0Y2hlci5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBpc0Z1bmN0aW9uID0gcmVxdWlyZSgnLi9mdW5jdGlvbicpXG5cbi8qKlxuICogQGZ1bmMgaXNNYXRjaGVyXG4gKiBAbWVtYmVyT2YgaXNcbiAqIEBzaW5jZSAzLjAuMFxuICpcbiAqIEBwYXJhbSAgeyp9IHggdmFsdWUgdG8gY2hlY2tcbiAqIEByZXR1cm4ge2Jvb2xlYW59IGlzRnVuY3Rpb24gfHwgaXNSZWdFeHBcbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqICAgIGlzTWF0Y2hlcigvKC4qKS8pXG4gKiAgICAvLz0+IHRydWVcbiAqXG4gKiAgICBpc01hdGNoZXIoeCA9PiB0cnVlKVxuICogICAgLy89PiB0cnVlXG4gKlxuICogICAgaXNNYXRjaGVyKDEpXG4gKiAgICAvLz0+IGZhbHNlXG4gKiAgICBpc01hdGNoZXIoJy4qJylcbiAqICAgIC8vPT4gZmFsc2VcbiAqXG4gKi9cbm1vZHVsZS5leHBvcnRzID0geCA9PiBpc0Z1bmN0aW9uKHgpIHx8IHggaW5zdGFuY2VvZiBSZWdFeHBcbiJdLCJuYW1lcyI6WyJjb25zdCJdLCJtYXBwaW5ncyI6IkFBQUFBLEdBQUssQ0FBQyxVQUFVLEdBQUcsT0FBTyxDQUFDLFlBQVksQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBd0J4QyxNQUFNLENBQUMsT0FBTyxHQUFHLFVBQUEsQ0FBQyxDQUFBLENBQUMsQUFBRyxTQUFBLFVBQVUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFlBQVksTUFBTSxHQUFBOyJ9